import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Download } from "lucide-react";
import { TxTable } from "./InventoryShared";

const TYPES = ["INITIAL_STOCK", "PURCHASE", "SALE", "POS_SALE", "ONLINE_SALE", "HOLD", "HOLD_RELEASE", "RESERVATION", "RESERVATION_RELEASE", "RETURN", "REFUND", "DAMAGE", "ADJUSTMENT", "IMPORT", "TRANSFER", "RESTOCK", "CORRECTION"];

export const downloadCsv = async (path, params, filename) => {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};

export const InventoryHistoryTab = () => {
  const [f, setF] = useState({ q: "", sku: "", transaction_type: "", location_id: "", date_from: "", date_to: "", page: 1 });
  const [data, setData] = useState(null);
  const [locs, setLocs] = useState([]);
  const params = Object.fromEntries(Object.entries({ ...f, per_page: 50 }).filter(([, v]) => v !== ""));

  useEffect(() => { api.get("/inventory/locations").then((r) => setLocs(r.data)); }, []);
  useEffect(() => {
    const t = setTimeout(() => api.get("/inventory/transactions", { params }).then((r) => setData(r.data)), 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [f]);

  const set = (k, v) => setF((x) => ({ ...x, [k]: v, page: 1 }));
  const inp = "h-10 rounded-lg border border-slate-200 px-3 text-sm bg-white";
  return (
    <div data-testid="history-tab">
      <div className="flex flex-wrap justify-between items-center gap-3 mb-4">
        <div>
          <div className="font-heading text-2xl text-brand-navy">Transaction History</div>
          <div className="text-xs text-slate-500">Every inventory change, permanently recorded · {data?.total ?? 0} entries</div>
        </div>
        <button data-testid="history-export-btn" onClick={() => downloadCsv("/inventory/transactions", { ...params, format: "csv" }, "inventory-transactions.csv")}
          className="inline-flex items-center gap-1 bg-brand-navy text-white rounded-full h-10 px-4 font-bold text-sm"><Download className="h-4 w-4" /> Export CSV</button>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl p-3 mb-4 grid gap-2 sm:grid-cols-3 lg:grid-cols-6">
        <input data-testid="history-search" className={inp} placeholder="Product / SKU / user" value={f.q} onChange={(e) => set("q", e.target.value)} />
        <input data-testid="history-sku" className={inp} placeholder="Exact SKU" value={f.sku} onChange={(e) => set("sku", e.target.value)} />
        <select data-testid="history-type" className={inp} value={f.transaction_type} onChange={(e) => set("transaction_type", e.target.value)}>
          <option value="">All types</option>{TYPES.map((t) => <option key={t} value={t}>{t.replace(/_/g, " ")}</option>)}
        </select>
        <select data-testid="history-location" className={inp} value={f.location_id} onChange={(e) => set("location_id", e.target.value)}>
          <option value="">All locations</option>{locs.map((l) => <option key={l.location_id} value={l.location_id}>{l.name}</option>)}
        </select>
        <input data-testid="history-from" type="date" className={inp} value={f.date_from} onChange={(e) => set("date_from", e.target.value)} />
        <input data-testid="history-to" type="date" className={inp} value={f.date_to} onChange={(e) => set("date_to", e.target.value)} />
      </div>
      <TxTable txs={data?.items} />
      {data && data.total > 50 && (
        <div className="flex justify-between items-center p-3 text-sm">
          <button disabled={f.page <= 1} onClick={() => setF((x) => ({ ...x, page: x.page - 1 }))} className="font-bold disabled:opacity-40">← Prev</button>
          <span className="text-slate-500">Page {f.page} of {Math.ceil(data.total / 50)}</span>
          <button disabled={f.page * 50 >= data.total} onClick={() => setF((x) => ({ ...x, page: x.page + 1 }))} className="font-bold disabled:opacity-40">Next →</button>
        </div>
      )}
    </div>
  );
};
